/**
 * Optional ID fields: empty / whitespace-only is valid.
 * Aadhaar: exactly 12 digits (spaces ignored when counting).
 * PAN: 10 chars — 5 letters, 4 digits, 1 letter (case-insensitive input).
 */

export function validateAadharOptional(raw) {
  const trimmed = String(raw ?? "").trim();
  if (!trimmed) return { ok: true, normalized: "" };

  const digits = trimmed.replace(/\D/g, "");
  if (!/^\d{12}$/.test(digits)) {
    return {
      ok: false,
      message: "Aadhaar must be exactly 12 digits.",
    };
  }
  return { ok: true, normalized: digits };
}

export function validatePanOptional(raw) {
  const trimmed = String(raw ?? "").trim();
  if (!trimmed) return { ok: true, normalized: "" };

  const upper = trimmed.toUpperCase();
  if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(upper)) {
    return {
      ok: false,
      message:
        "PAN must be 10 characters: 5 letters, 4 digits, 1 letter (e.g. ABCDE1234F).",
    };
  }
  return { ok: true, normalized: upper };
}
